// extracted by mini-css-extract-plugin
export var contactImage = "TreatmentIntroSection-module--contactImage--40ee5";
export var contentContainer = "TreatmentIntroSection-module--contentContainer--4226d";
export var contentContainerStyling = "TreatmentIntroSection-module--contentContainerStyling--4d3c8";
export var contentRowContainerStyling = "TreatmentIntroSection-module--contentRowContainerStyling--856ed";
export var contentStyling = "TreatmentIntroSection-module--contentStyling--9eb6a";
export var contentVideoWidth = "TreatmentIntroSection-module--contentVideoWidth--610c4";
export var darkBgStyling = "TreatmentIntroSection-module--darkBgStyling--f859e";
export var headingContainerStyling = "TreatmentIntroSection-module--headingContainerStyling--434c1";
export var mobileImage = "TreatmentIntroSection-module--mobileImage--daa39";
export var sectionBackGround = "TreatmentIntroSection-module--sectionBackGround--bb7d2";
export var sectionContainer = "TreatmentIntroSection-module--sectionContainer--7ec15";
export var videoContainer = "TreatmentIntroSection-module--videoContainer--01b1d";